var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPremiumTag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 55.421,
    height: 15,
    viewBox: "0 0 55.421 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1",
    "data-name": "Group 1",
    transform: "translate(-709 -431)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union_1",
    "data-name": "Union 1",
    d: "M36,6.5l.6-2.9a2.8,2.8,0,0,0,.1-.6.353.353,0,0,0-.4-.4,1.022,1.022,0,0,0-.8.5A4.362,4.362,0,0,0,35,4.4l-.4,2.1H33.3l.6-2.8a1.759,1.759,0,0,0,.1-.6.353.353,0,0,0-.4-.4.6.6,0,0,0-.4.1c-.1.1-.3.2-.4.3a1.632,1.632,0,0,0-.3.6c0,.1-.1.3-.2.7l-.4,2.1H30.6l.9-4.7h1.2l-.1.6a1.931,1.931,0,0,1,1.5-.7,1.551,1.551,0,0,1,.8.2.917.917,0,0,1,.4.6,4.4,4.4,0,0,1,.7-.6,1.487,1.487,0,0,1,.9-.2,1.222,1.222,0,0,1,.9.3,1.137,1.137,0,0,1,.3.8,2.817,2.817,0,0,1-.1.8l-.6,2.9ZM25.6,6.2a1.223,1.223,0,0,1-.3-.9,4.594,4.594,0,0,1,.1-1L26,1.8h1.3l-.6,2.8a1.762,1.762,0,0,0-.1.6.367.367,0,0,0,.1.3c.1.1.2.1.4.1a.367.367,0,0,0,.3-.1c.1,0,.2-.1.3-.2L28,5c.1-.1.2-.3.3-.4s.1-.4.2-.7L29,1.7h1.3l-1,4.7H28.1l.1-.6a2.34,2.34,0,0,1-1.7.7A1.225,1.225,0,0,1,25.6,6.2Zm-3.1.3,1-4.7h1.3l-1,4.7ZM20,6.5l.6-2.9a2.8,2.8,0,0,0,.1-.6.353.353,0,0,0-.4-.4,1.019,1.019,0,0,0-.8.5A4.333,4.333,0,0,0,19,4.4l-.4,2.1H17.3l.6-2.8a1.759,1.759,0,0,0,.1-.6.353.353,0,0,0-.4-.4.6.6,0,0,0-.4.1c-.1.1-.3.2-.4.3a1.638,1.638,0,0,0-.3.6c0,.1-.1.3-.2.7l-.4,2.1H14.6l.9-4.7h1.2l-.1.6a1.933,1.933,0,0,1,1.5-.7,1.549,1.549,0,0,1,.8.2.917.917,0,0,1,.4.6,4.4,4.4,0,0,1,.7-.6,1.489,1.489,0,0,1,.9-.2,1.222,1.222,0,0,1,.9.3,1.133,1.133,0,0,1,.3.8,2.817,2.817,0,0,1-.1.8l-.6,2.9Zm-9.7-.6a2.113,2.113,0,0,1-.6-1.6,3.372,3.372,0,0,1,.5-1.7,2.394,2.394,0,0,1,2.1-1,2.168,2.168,0,0,1,1.4.5,2.254,2.254,0,0,1,.5,1.5c0,.4-.1.6-.1.9H10.9v.1a1.137,1.137,0,0,0,.3.8.867.867,0,0,0,.6.3c.4,0,.7-.2,1-.7l1.1.2a1.787,1.787,0,0,1-.9,1,2.664,2.664,0,0,1-1.2.3A2.037,2.037,0,0,1,10.3,5.9Zm1.2-3.1a1.886,1.886,0,0,0-.4.9H13V3.6a1.886,1.886,0,0,0-.2-.8.863.863,0,0,0-.6-.3A.907.907,0,0,0,11.5,2.8ZM6,6.4l.9-4.6H8.1l-.2.9a1.661,1.661,0,0,1,1.4-1,1.269,1.269,0,0,1,.6.1l-.5,1c-.1,0-.2-.1-.4-.1a2.554,2.554,0,0,0-.7.2,1.8,1.8,0,0,0-.5.7,6.827,6.827,0,0,0-.4,1.3L7.1,6.4Zm-6,0L1.3,0H3.9A3.085,3.085,0,0,1,5,.2a1.024,1.024,0,0,1,.6.5,1.486,1.486,0,0,1,.2.9,2.928,2.928,0,0,1-.2.9,1.28,1.28,0,0,1-.5.7,2.106,2.106,0,0,1-.6.4,2,2,0,0,1-.9.2h-2L1.4,6.4ZM2.1,2.9h.4a4.544,4.544,0,0,0,1.4-.1,2.081,2.081,0,0,0,.6-.4.737.737,0,0,0,.2-.6c0-.2,0-.3-.1-.4s-.2-.2-.3-.2a5.4,5.4,0,0,0-.8-.1H2.6ZM23.7,1.1,23.9,0h1.3L25,1.1Z",
    transform: "translate(726.321 435.576)",
    fill: "#c18e1a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Union_2",
    "data-name": "Union 2",
    d: "M0,7.5A7.5,7.5,0,1,1,7.5,15,7.5,7.5,0,0,1,0,7.5Z",
    transform: "translate(709 431)",
    fill: "#ffd600"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8",
    "data-name": "Path 8",
    d: "M8.4,2,6,2.9c-.2.1-.5-.1-.6-.3h0L4.6.1A.367.367,0,0,0,4.3,0L4.2.1,3.4,2.6c-.1.2-.4.4-.6.3h0L.4,2c-.2,0-.3,0-.3.1v.2L1.4,5a1.34,1.34,0,0,0,1.3.8H6.2A1.561,1.561,0,0,0,7.5,5L8.8,2.2c.1-.1,0-.2-.1-.3C8.5,2,8.5,2,8.4,2Z",
    transform: "translate(712.066 434.907)",
    fill: "#c18e1a"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1",
    "data-name": "Line 1",
    x2: 5.4,
    transform: "translate(713.748 441.922)",
    fill: "none",
    stroke: "#c18e1a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPremiumTag);
export default __webpack_public_path__ + "static/media/premium-tag.81e1e5e36df434b698a779da7f464990.svg";
export { ForwardRef as ReactComponent };